var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlert = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70.974,
    height: 70.974,
    viewBox: "0 0 70.974 70.974",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-alert{fill:#fd5965}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert_Icon",
    "data-name": "Alert Icon",
    transform: "translate(-648 -276.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_125460",
    "data-name": "Path 125460",
    className: "cls-alert",
    d: "M347.487 83.974a35.487 35.487 0 1 1 35.487-35.487 35.488 35.488 0 0 1-35.487 35.487zm0-6.452a29.034 29.034 0 1 0-20.531-8.5 29.032 29.032 0 0 0 20.531 8.5z",
    transform: "translate(336 263.756)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158227",
    "data-name": "Path 158227",
    className: "cls-alert",
    d: "M2.873 16.389q-2.071 0-2.23-2.443L-.951-6.34A4.18 4.18 0 0 1-.1-9.5a3.674 3.674 0 0 1 2.974-1.195A3.53 3.53 0 0 1 5.767-9.5a4.248 4.248 0 0 1 .823 3.16L5 13.946q-.162 2.443-2.127 2.443zm0 11.046A3.861 3.861 0 0 1-.021 26.32a3.933 3.933 0 0 1-1.089-2.868 3.775 3.775 0 0 1 1.089-2.788 3.912 3.912 0 0 1 2.894-1.089 3.8 3.8 0 0 1 2.894 1.089A3.881 3.881 0 0 1 6.8 23.452a4.047 4.047 0 0 1-1.033 2.868 3.754 3.754 0 0 1-2.894 1.115z",
    transform: "translate(680.641 303.873)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alert.fc755546.svg";
export { ForwardRef as ReactComponent };